<template>
  <v-container>
    <v-row no-gutters class="support-snippet">
      <v-col cols="12" class="text-center pa-2">
        <strong>
          Call us on
          <a
            :href="`tel:${whitelabel.insuranceCallUsTel.replace(/\s+/g, '')}`"
            >{{ whitelabel.insuranceCallUsTel }}</a
          >
          or<br />
          for more information
          <GradientButton
            :title="'request a call'"
            :small="true"
            :fill="false"
            :buttonSize="'small'"
            :loading="buttonLoading"
            @gradientButtonClicked="requestACall()"
          />
        </strong>
      </v-col>
    </v-row>

    <ErrorSnackbar v-model="showError" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </v-container>
</template>

<script>
  import { REQUEST_A_CALL_MUTATION } from '../../constants/graphql/testators';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import SuccessSnackbar from '../common/SuccessSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';

  export default {
    name: 'SupportSnippet',
    components: {
      ErrorSnackbar,
      SuccessSnackbar,
    },
    mixins: [formHelperMixin],
    data() {
      return {
        isHomePage: false,
        showSuccess: false,
        successMessage: null,
      };
    },
    methods: {
      requestACall() {
        if (this.buttonLoading) return;

        this.buttonLoading = true;

        this.$apollo
          .mutate({
            mutation: REQUEST_A_CALL_MUTATION,
            variables: {
              testatorId: this.testatorId,
              forInsurance: true,
            },
          })
          .then(response => {
            response.data.requestACall
              ? this.showSuccessMessage()
              : this.displayError();
          })
          .catch(error => {
            this.displayError();
            throw error;
          });
      },
      showSuccessMessage() {
        this.successMessage =
          'Thank you. One of our specialists will contact you to assist.';
        this.showSuccess = true;
        this.buttonLoading = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .support-snippet {
    margin-top: 20px;
    margin: auto;
    border: 1px solid rgb(128, 128, 128, 0.2);
    background-color: rgb(128, 128, 128, 0.1);
    border-radius: 3px;
    padding: 5px;
  }

  .support-phone {
    margin: 7px;
    padding: 7px;
    border: solid 1px;
    border-radius: 50%;
  }
</style>
